import { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { dramas } from '@/mocks/dramas';
import FilterSidebar from './components/FilterSidebar';
import { DramaGrid } from './components/DramaCard';

export default function CategoryPage() {
  const [filters, setFilters] = useState({
    region: '全部',
    genre: '全部',
    year: '全部',
    rating: '全部',
  });
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const handleFilterChange = (key: string, value: string) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const filtered = useMemo(() => {
    return dramas.filter((d) => {
      if (filters.region !== '全部' && d.region !== filters.region) return false;
      if (filters.genre !== '全部' && d.genre !== filters.genre) return false;
      if (filters.year !== '全部') {
        if (filters.year === '经典') {
          if (d.year >= 2023) return false;
        } else {
          if (String(d.year) !== filters.year) return false;
        }
      }
      if (filters.rating !== '全部') {
        if (filters.rating === '9分以上' && d.rating < 9) return false;
        if (filters.rating === '8-9分' && (d.rating < 8 || d.rating >= 9)) return false;
        if (filters.rating === '7-8分' && (d.rating < 7 || d.rating >= 8)) return false;
        if (filters.rating === '6-7分' && (d.rating < 6 || d.rating >= 7)) return false;
      }
      return true;
    });
  }, [filters]);

  const activeCount = Object.values(filters).filter((v) => v !== '全部').length;

  const clearFilters = () => {
    setFilters({ region: '全部', genre: '全部', year: '全部', rating: '全部' });
  };

  return (
    <div className="min-h-screen bg-background-50">
      <header className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200">
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-[72px] max-w-[1400px] mx-auto">
            <Link
              to="/"
              className="flex items-center gap-2 text-foreground-950 no-underline cursor-pointer"
            >
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading text-lg">
                努
              </span>
              <span className="text-xl font-heading font-bold whitespace-nowrap">努努影院</span>
            </Link>
            <div className="flex items-center gap-3">
              <span className="hidden sm:inline text-sm text-foreground-400">电视剧分类浏览</span>
              <button
                onClick={() => setMobileSidebarOpen(true)}
                className="md:hidden inline-flex items-center gap-1.5 px-3 py-1.5 bg-background-100 text-foreground-600 text-xs font-medium rounded-full cursor-pointer"
              >
                <i className="ri-filter-3-line"></i>
                筛选
                {activeCount > 0 && (
                  <span className="w-4 h-4 flex items-center justify-center bg-primary-500 text-background-50 text-[10px] rounded-full">{activeCount}</span>
                )}
              </button>
            </div>
          </div>
        </div>
      </header>

      <div className="pt-[72px] flex">
        <FilterSidebar
          activeFilters={filters}
          onFilterChange={handleFilterChange}
          mobileOpen={mobileSidebarOpen}
          onMobileClose={() => setMobileSidebarOpen(false)}
        />

        <div className="flex-1 min-w-0 p-4 md:p-6 lg:p-8 md:ml-[220px]">
          <div className="max-w-[1280px] mx-auto">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-3">
                <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                  电视剧分类
                </h1>
                <span className="text-xs text-foreground-400">共 {filtered.length} 部</span>
              </div>
              {activeCount > 0 && (
                <button
                  onClick={clearFilters}
                  className="text-xs text-primary-500 hover:text-primary-600 font-medium cursor-pointer flex items-center gap-1"
                >
                  <i className="ri-close-circle-line"></i>
                  清除筛选
                </button>
              )}
            </div>

            {filtered.length > 0 ? (
              <DramaGrid dramas={filtered} />
            ) : (
              <div className="flex flex-col items-center justify-center py-20 text-center">
                <span className="w-16 h-16 flex items-center justify-center bg-background-100 text-foreground-300 rounded-full mb-4 text-3xl">
                  <i className="ri-film-line"></i>
                </span>
                <p className="text-sm text-foreground-500 mb-2">暂无符合条件的剧集</p>
                <button
                  onClick={clearFilters}
                  className="text-xs text-primary-500 hover:text-primary-600 font-medium cursor-pointer"
                >
                  清除筛选条件
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}